export interface IContentForum {
  topic: ITopic;
  id: number;
}
export interface IForum {
  topics?: ITopic[];
  selectedTopic?: ISelectedTopic;
  editComment?: number;
  comments?: IComment;
  loader: boolean;
}

export interface IComment {
  current_page: number;
  data: ICommentInformations[];
  first_page_url: string;
  from: number;
  last_page: number;
  last_page_url: string;
  next_page_url: any;
  path: string;
  per_page: number;
  prev_page_url: any;
  to: number;
  total: number;
}

export interface ICommentInformations {
  id: number;
  text: string;
  thread_id: number;
  user_id: number;
  votes: number;
  moderate_at: string;
  modified_at: string;
  created_at: string;
  updated_at: string;
  deleted_at: string;
  user: IOwnerInformations;
}

export interface ITopic {
  id: number;
  title: string;
  replaces: number;
}

export interface IOwnerInformations {
  id: number;
  name: string;
  email: string;
  avatar?: string;
  deleted_at?: any;
  created_at?: any;
  updated_at?: any;
}

export interface ITopicInformations extends Partial<IComment> {
  title: string;
}

export interface ISelectedTopic {
  id?: number;
  title?: string;
  text?: string;
  closed?: any;
  group_id?: number;
  user_id?: number;
  created_at?: any;
  updated_at?: any;
  deleted_at?: any;
  user?: IOwnerInformations;
}

export enum enStatus {
  producer = 'producer',
  learner = 'learner'
}
